import $ from 'jquery';
import TriggeredGuideManager from './manager';
import TriggeredGuide from './guide';

$(() => {
  if (!window.tower.triggered_guides || window.tower.triggered_guides.length === 0) {
    return;
  }

  const manager = new TriggeredGuideManager();

  const guideConfigs = window.tower.triggered_guides;

  guideConfigs.forEach((guideConfig) => {
    manager.guides.add(new TriggeredGuide(manager, guideConfig));
  });

  window.tower.stack.on('pageload', () => {
    const guideConfig = TriggeredGuideManager.retrieveGuideFromShowLater();
    if (guideConfig) {
      const guide = new TriggeredGuide(manager, guideConfig);
      console.debug(`Retrieve guide ${guide.key} from show later`);
      guide.showGuide()
        .then((result) => {
          if (result) TriggeredGuideManager.clearShowLater();
        })
        .catch(e => console.error(e));
    }
  });
});
